// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/Icons/defaultSideBarHeaderDivider.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenu-sideMenuContent-mXbrW {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	width: 100%;
}

.SideMenu-sideMenuHeader-FY6lx {
	position: relative;
	padding: 24px 35px;
	text-align: center;
	color: var(--sideMenu-primary-foreground);
	font-size: 20px;
	font-weight: 600;
	line-height: 30px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	gap: 16px;
	grid-gap: 16px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-bottom: 24px;
}

.SideMenu-sideMenuHeader-FY6lx::before {
	content: "";
	position: absolute;
	bottom: 0;
	left: 50%;
	width: 140px;
	height: 6px;
	-webkit-transform: translateX(-50%);
	    -ms-transform: translateX(-50%);
	        transform: translateX(-50%);
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
}

.SideMenu-sideMenuBody-ycmqU {
	padding-bottom: 80px;
	height: 100%;
	-webkit-box-flex: 1;
	    -ms-flex-positive: 1;
	        flex-grow: 1;
	overflow-y: auto;
}

.SideMenu-sideMenuBody-ycmqU::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}

.SideMenu-sideMenuBody-ycmqU::-webkit-scrollbar-thumb {
	background: var(--primary-bg);
	border-radius: calc(var(--radius-1)*2);
}

.SideMenu-sideMenuBody-ycmqU::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 5px var(--border-color);
	        box-shadow: inset 0 0 5px var(--border-color);
	border-radius: calc(var(--radius-1)*2);
}

@-moz-document url-prefix() {

	/* Support above Firefox 64 (December 2018). */
	.SideMenu-sideMenuBody-ycmqU {
		scrollbar-width: thin;
		scrollbar-color: var(--primary-bg) transparent;
	}
}

.SideMenu-sideMenuHeaderLogoContainer-hBKmp {
	position: relative;
	width: 100%;
	max-width: 154px;
	height: 55px;
}

.SideMenu-sideMenuHeaderLogo-bjc7j,
.SideMenu-sideMenuHeaderLogo-bjc7j img {
	position: absolute;
	width: 100%;
	height: 100%;
	inset: 0;
}

.SideMenu-sideMenuHeaderLogo-bjc7j img {
	-o-object-fit: contain;
	   object-fit: contain;
	-o-object-position: center;
	   object-position: center;
}

.SideMenu-sideMenuHeaderLogoText-OumLX,
.SideMenu-sideMenuHeaderLogoText-OumLX:hover,
.SideMenu-sideMenuHeaderLogoText-OumLX:focus {
	font-size: 18px;
	font-weight: 500;
	line-height: 28px;
	text-decoration: none;
	white-space: pre-line;
	word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/SideMenu/SideMenu.css"],"names":[],"mappings":"AAAA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,yCAAyC;CACzC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,SAAS;CACT,cAAc;CACd,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,YAAY;CACZ,WAAW;CACX,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;CAC3B,yDAA8E;CAC9E,4BAA4B;CAC5B,wBAAwB;CACxB,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,mBAAY;KAAZ,oBAAY;SAAZ,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,6BAA6B;CAC7B,sCAAwC;AACzC;;AAEA;CACC,qDAA6C;SAA7C,6CAA6C;CAC7C,sCAAwC;AACzC;;AAEA;;CAEC,8CAA8C;CAC9C;EACC,qBAAqB;EACrB,8CAA8C;CAC/C;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,YAAY;AACb;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,QAAQ;AACT;;AAEA;CACC,sBAAmB;IAAnB,mBAAmB;CACnB,0BAAuB;IAAvB,uBAAuB;AACxB;;AAEA;;;CAGC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,qBAAqB;CACrB,sBAAsB;AACvB","sourcesContent":[".sideMenuContent {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.sideMenuHeader {\n\tposition: relative;\n\tpadding: 24px 35px;\n\ttext-align: center;\n\tcolor: var(--sideMenu-primary-foreground);\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tline-height: 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\tgrid-gap: 16px;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-bottom: 24px;\n}\n\n.sideMenuHeader::before {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 50%;\n\twidth: 140px;\n\theight: 6px;\n\ttransform: translateX(-50%);\n\tbackground-image: url('../../../public/Icons/defaultSideBarHeaderDivider.png');\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tbackground-position: center;\n}\n\n.sideMenuBody {\n\tpadding-bottom: 80px;\n\theight: 100%;\n\tflex-grow: 1;\n\toverflow-y: auto;\n}\n\n.sideMenuBody::-webkit-scrollbar {\n\twidth: 5px;\n\theight: 5px;\n}\n\n.sideMenuBody::-webkit-scrollbar-thumb {\n\tbackground: var(--primary-bg);\n\tborder-radius: calc(var(--radius-1) * 2);\n}\n\n.sideMenuBody::-webkit-scrollbar-track {\n\tbox-shadow: inset 0 0 5px var(--border-color);\n\tborder-radius: calc(var(--radius-1) * 2);\n}\n\n@-moz-document url-prefix() {\n\n\t/* Support above Firefox 64 (December 2018). */\n\t.sideMenuBody {\n\t\tscrollbar-width: thin;\n\t\tscrollbar-color: var(--primary-bg) transparent;\n\t}\n}\n\n.sideMenuHeaderLogoContainer {\n\tposition: relative;\n\twidth: 100%;\n\tmax-width: 154px;\n\theight: 55px;\n}\n\n.sideMenuHeaderLogo,\n.sideMenuHeaderLogo img {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tinset: 0;\n}\n\n.sideMenuHeaderLogo img {\n\tobject-fit: contain;\n\tobject-position: center;\n}\n\n.sideMenuHeaderLogoText,\n.sideMenuHeaderLogoText:hover,\n.sideMenuHeaderLogoText:focus {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tline-height: 28px;\n\ttext-decoration: none;\n\twhite-space: pre-line;\n\tword-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuContent": `SideMenu-sideMenuContent-mXbrW`,
	"sideMenuHeader": `SideMenu-sideMenuHeader-FY6lx`,
	"sideMenuBody": `SideMenu-sideMenuBody-ycmqU`,
	"sideMenuHeaderLogoContainer": `SideMenu-sideMenuHeaderLogoContainer-hBKmp`,
	"sideMenuHeaderLogo": `SideMenu-sideMenuHeaderLogo-bjc7j`,
	"sideMenuHeaderLogoText": `SideMenu-sideMenuHeaderLogoText-OumLX`
};
module.exports = ___CSS_LOADER_EXPORT___;
